import React from 'react';
import { getCategories } from 'actions';
import { randomString } from 'helpers/string';
import AuctionsSearchPage from 'components/Auctions/AuctionSearchPage';

const OnlineSearch = () => {
    return (
        <AuctionsSearchPage />
    );
};

OnlineSearch.getInitialProps = async ({store: { dispatch }, query}, { auction: { categories } })  => {
    await Promise.all([
        new Promise(async (resolve) => {
            !categories.length && await dispatch(getCategories());

            resolve();
        }),
    ]);

    const pageData = {
        h1: undefined,
        description: undefined,
        title: 'Online Storage Auctions',
        marginBottom: 'pageTitle marginB20',
    };

    const rand_str = randomString();

    return { query, rand_str, pageData };
};

export default OnlineSearch;